import { render, staticRenderFns } from "./showLanguage.vue?vue&type=template&id=f23e4cc2&scoped=true"
import script from "./showLanguage.vue?vue&type=script&lang=js"
export * from "./showLanguage.vue?vue&type=script&lang=js"
import style0 from "./showLanguage.vue?vue&type=style&index=0&id=f23e4cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23e4cc2",
  null
  
)

export default component.exports